import { get, post } from '@/utils/request'

const classifyApi = {
  /* 删除 */
  deleteById: function (id) {
    return post('/card/classify/delete/' + id)
  },
  /* 查看详情 */
  viewDetail: function (id) {
    return get('/card/classify/detail/' + id)
  },
  /* 卡密业务-商品类目，获取所有 */
  getAll: function () {
    return get('/card/classify/list-all')
  },
  /* 添加或编辑 */
  saveForm: function (params) {
    return post('/card/classify/save-update', {
      id: params.id,
      typeName: params.typeName,
      businessType: params.businessType,
      remarks: params.remarks,
      typeStatus: params.typeStatus
      // provinceCode: params.provinceCode
    })
  },
  /* 添加或编辑初始化 */
  getInit: function (id) {
    return get('/card/classify/save-update-init', {
      id
    })
  }
}
export default classifyApi



// WEBPACK FOOTER //
// ./src/api/classify.js